export enum ObjectModelTriggerRunsForType {
  Individual = 0,
  Collection = 1,
}